var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.871 511.871",
    height: 512,
    viewBox: "0 0 511.871 511.871",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408.695 122.415c-7.256-7.256-16.384-12.175-26.22-14.321-2.146-9.836-7.065-18.964-14.321-26.22-20.704-20.704-54.391-20.703-75.095 0-22.313 22.02-23.728 63.799-8.656 124.292 60.492 15.072 102.272 13.657 124.292-8.656 20.704-20.704 20.704-54.391 0-75.095zm-99.17 58.629c-10.211-49.945-3.229-69.98 4.748-77.957 9.007-9.007 23.661-9.007 32.668 0 9.466 8.784 6.144 24.065 5.572 34.969 9.992-.553 27-3.816 34.969 5.572 9.007 9.007 9.006 23.661 0 32.668-7.977 7.977-28.012 14.96-77.957 4.748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.885 280.5c55.913 28.834 126.433 19.857 173.238-26.948 57.927-57.927 57.927-152.181 0-210.107s-152.18-57.926-210.107 0c-46.806 46.806-55.783 117.326-26.948 173.238l-188.766 188.768 63.816 63.816 21.302-21.302 63.905 63.905 106.42-106.42-63.905-63.905zm-188.679 146.253-.088.088-21.39-21.39 163.135-163.135c3.16 3.875 6.544 7.626 10.154 11.236s7.361 6.994 11.236 10.154zm173.025-194.415c-46.23-46.23-46.23-121.451 0-167.68 46.23-46.23 121.451-46.23 167.681 0s46.23 121.451 0 167.681c-46.231 46.229-121.452 46.229-167.681-.001zm-87.907 237.106-42.692-42.692 21.39-21.39 42.692 42.692zm63.994-63.993-21.39 21.39-42.692-42.692 21.39-21.39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon_key.ee85ccca8d46f5f43065c58e1ca5ae90.svg";
export { ForwardRef as ReactComponent };